import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CustomerSignAgreementDialogComponent } from './customer-sign-agreement-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class CustomerSignAgreementDialogService {
  constructor(private dialog: MatDialog) {}

  public open(name: string): Observable<boolean> {
    let dialogRef: MatDialogRef<CustomerSignAgreementDialogComponent>;
    dialogRef = this.dialog.open(CustomerSignAgreementDialogComponent, {
      data: {
        name: name,
      },
      maxWidth: window.screen.width < 560 ? '90vw' : '60vw',
    });
    return dialogRef.afterClosed();
  }
}
